/**
 * 재처리 요청 mutation 훅.
 *
 * 성공 시 해당 Job 상세를 무효화하여 ``pending_extraction`` 폴링 효과를 얻는다.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { requestReprocess, type ReprocessOut } from "@/lib/api/records";
import { jobDetailKey } from "@/features/jobs/useJobDetail";

interface Variables {
  jobId: string;
  fileId: string;
}

export function useReprocess() {
  const qc = useQueryClient();
  return useMutation<ReprocessOut, Error, Variables>({
    mutationFn: ({ jobId, fileId }) => requestReprocess(jobId, fileId),
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: jobDetailKey(vars.jobId) });
    },
  });
}
